import { useEffect, useState } from 'react';
import api from '../services/api';

export interface MyStoricoItem {
  sku: string;
  title: string;
  brand: string;
  /** Colore dell'articolo, vuoto se non ne ha. */
  color: string;
  totQuantita: number;
  totSpesa: number;
  numOrdini: number;
  prezzoMedio: number;
  ultimoAcquisto: string | null;
  ordini: { id: string; tipork: string; anno: number; serie: string; numdoc: number; date: string; qty: number; prezzo: number }[];
  // dati prodotto correnti
  stockCorrente: number | null;
  prezzoCorrente: number | null;
  isKit: boolean;
  minimoVendibile: number;
}

export interface MyStoricoResp {
  mesi: number;
  cutoff: string;
  totals: {
    skuCount: number;
    totQuantita: number;
    totSpesa: number;
    ordiniCount: number;
  };
  items: MyStoricoItem[];
}

export function useMyStoricoAcquisti(mesi: number = 12) {
  const [data, setData] = useState<MyStoricoResp | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    api
      .get<MyStoricoResp>(`/api/clienti/me/storico-acquisti?mesi=${mesi}`)
      .then((r) => setData(r.data))
      .catch((e) => setError(e?.response?.data?.detail ?? 'Errore caricamento storico'))
      .finally(() => setLoading(false));
  }, [mesi]);

  return { data, loading, error };
}
